import { DEALS_FILTER_VALUES } from 'client/site-modules/shared/constants/lease-deals/lease-deals';

export const MOBILE_IMAGE_WIDTH = 500;
export const DESKTOP_IMAGE_WIDTH = 815;

export const EDM_LEASE_DEALS_HERO_CREATIVE_ID = 'edm-lease-deals-hero';
export const NATIONAL_LEASE_DEALS_PAGE_URL = '/lease-deals/';
export const EDM_LEASE_DEALS_LOW_INVENTORY_CREATIVE_ID = 'edm-lease-deals-low-results';
export const EDM_LEASE_DEALS_VEHICLE_CARD_CREATIVE_ID = 'edm-lease-deals-vehicle-card';
export const LEASE_DEALS_FILTERS = 'edm-lease-deals-filters';
export const EDM_LEASE_DEALS_VEHICLE_DETAIL_CREATIVE_ID = 'edm-lease-deals-vehicle-detail';
export const EDM_LEASE_DEALS_STICKY_CTA_CREATIVE_ID = 'edm-lease-deals-sticky-cta';
export const EDM_LEASE_DEALS_PAGINATION = 'edm-lease-deals-pagination';
export const EDM_LEASE_DEALS_SORT = 'edm-lease-deals-sort';

export const LEASE_DEALS_CARD_LIST_ANCHOR = 'lease-deals-card-list';

export const EDM_LEASE_DEAL_INSIGHTS_CREATIVE_ID = 'edm-lease-deals-insights';
export const EDM_LEASE_DEALS_HOW_WE_EVALUATE_CREATIVE_ID = 'edm-lease-deals-how-we-evaluate';

export const LOW_INVENTORY_BUTTON_VARIANTS = [
  {
    id: 'view-all-specials',
    text: 'View all specials',
    action: 'onViewAllSpecials',
    icon: 'icon-list',
    tag: 'button',
    tabsDisplayedOn: [DEALS_FILTER_VALUES.GEMS],
    trackingEvent: {
      trackingId: 'low_inventory_view_all_specials',
      value: 'All Specials',
    },
  },
  {
    id: 'clear-all-filters',
    text: 'Clear all filters',
    action: 'onClearAllFilters',
    icon: 'icon-cross2',
    tag: 'button',
    tabsDisplayedOn: [DEALS_FILTER_VALUES.GEMS, DEALS_FILTER_VALUES.ALL],
    trackingEvent: {
      trackingId: 'low_inventory_clear_all_filters',
      value: 'Clear All',
    },
  },
  {
    id: 'shop-cars-for-lease',
    text: 'Shop cars for lease',
    action: 'onShopCarsForLease',
    tag: 'a',
    icon: 'icon-price-tags2',
    tabsDisplayedOn: [DEALS_FILTER_VALUES.GEMS, DEALS_FILTER_VALUES.ALL],
    trackingEvent: {
      trackingId: 'low_inventory_shop_all',
      value: 'Shop cars for lease',
    },
  },
];

export const DEFAULT_SEO_TITLE = 'Hidden Gems: The Best Lease Deals [{{month}} {{year}}] | Edmunds';
export const DEFAULT_SEO_DESCRIPTION =
  'Find the best car lease deals for {{month}} {{year}}. Edmunds curated top lease specials and flash deals across all makes and models – save big today.';
export const DEFAULT_JSONLD_NAME = 'Best Car Lease Deals in {{month}}';
export const DEFAULT_JSONLD_DESCRIPTION = 'A collection of the best car lease offers in {{month}}, {{year}}.';
export const DEFAULT_PAGE_TITLE = 'Hidden Gems: The Best Lease Deals in {{month}} {{year}}';
export const DEFAULT_PAGE_SUBTITLE =
  "{{month}} {{year}}'s top lease offers. Hundreds of lease offers are available, but only a select few stand out as Hidden Gems. We compared the advertised lease specials across all makes and models to find the best values based on payment & MSRP. Offers are subject to the automaker's terms. Check the program details for full pricing and lease information.";
